import { Box, cn, Image } from "@luce/ui";

import type { GiftCardOccasionType } from "../../../__generated__/graphql";
import { getGiftCardHero } from "../../lib";

interface GiftCardHeroProps {
  occasion: GiftCardOccasionType;
  muted?: boolean;
  className?: string;
}

export function GiftCardHero({ occasion, muted = false, className }: GiftCardHeroProps) {
  return (
    <Box className={cn("relative aspect-[114/64] w-full overflow-hidden rounded-xl", className)}>
      <Image
        src={getGiftCardHero(occasion)}
        alt=""
        fill
        contentFit="cover"
        className={cn(muted && "grayscale")}
      />
      {muted && <Box className="web:hidden absolute inset-0 bg-white/45" />}
    </Box>
  );
}
